import React, { useState } from "react";
import styles from "./EquityPaymentModal.module.scss";
import Modal from "../../../../common/Modals/Modal/Modal";
import Radio from "../../../../common/Formik/Radio/Radio";
import Button from "../../../../common/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { formatPrice } from "../../../../../utils/utils";
import {
  buyEquityTokensAction,
  getActiveCoinAction,
} from "../../../../../features/user/userSlice";
import { toasts } from "../../../../common/Toast/Toast";
import { useEffect } from "react";
import { STATUS_CODE } from "../../../../../utils/constants";

const EquityPaymentModal = ({
  show,
  handleClose,
  quantity,
  equityToken,
  onPurchaseSuccess,
}) => {
  const dispatch = useDispatch();

  const [selectedPayment, setSelectedPayment] = useState("STBL Wallet");
    const [activeCoins, setActiveCoins] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
  
    const fetchCoinOptions = async () => {
      setLoading(true);
      try {
        const response = await dispatch(getActiveCoinAction());
        if (response.data.status === STATUS_CODE.successful) {
          setActiveCoins(response.data.data.coinList || []);
        }
      } catch (error) {
        setError("Error fetching coin options.");
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchCoinOptions();
    }, []);

  const commonBalance = useSelector(
    (state) => state?.users?.commonWalletBalance?.amount || 0
  );

  const cryptoPrices = useSelector(
    (state) => state?.users?.cryptoPrice || {}
  );

  const handlePaymentMode = (value) => {
    setSelectedPayment(value);
  };

  const handlePlaceOrder = async () => {
    const coin =
      selectedPayment === "USDC"
        ? "USDC"
        : selectedPayment === "USDT"
        ? "USDT"
        : selectedPayment === "MATIC"
        ? "MATIC"
        : "STBL Wallet";

    if (!coin) {
      toasts.error("Invalid payment mode selected.");
      return;
    }

    const dataObj = {
      tokenId: equityToken?.id || 4,
      quantity: Number(quantity),
      type: coin === "STBL Wallet" ? "WIRE" : "CRYPTO",
      coin: coin,
    };

    try {
      
      const response = await dispatch(buyEquityTokensAction(dataObj));
      if (response.status === 200) {
        onPurchaseSuccess();
        handleClose();
      }
    } catch (error) {
      // console.error("Error placing order:", error);
      // toasts.error("Error purchasing tokens. Please try again.");
    }
  };

  return (
    <Modal
      className={styles.equity_modal}
      show={show}
      handleClose={handleClose}
      title="Equity Payment"
    >
      <div className={styles.modal_content}>
        <div className={styles.payment_method}>
          <h6>Select Payment Method</h6>

          {/* ✅ STBL Wallet (Static) */}
          <label>
            <Radio
              checked={selectedPayment === "STBL Wallet"}
              onChange={() => handlePaymentMode("STBL Wallet")}
              className={styles.radio}
              name="payment-method"
              value="STBL Wallet"
            />
            <h6>STBL Wallet</h6>
            <div className={styles.right_text}>
              <p>
                Bal: <span>${formatPrice(Number(commonBalance))}</span>
              </p>
            </div>
          </label>

          {/* ✅ Other Payment Coins (Dynamic, excluding STBL) */}
          {activeCoins
            ?.filter((coin) => coin.coin_symbol !== "STBL")
            .map((coin) => {

              return (
                <label key={coin.id}>
                  <Radio
                    checked={selectedPayment === coin.coin_symbol}
                    onChange={() =>
                      handlePaymentMode(coin.coin_symbol)
                    }
                    className={styles.radio}
                    name="payment-method"
                    value={coin.coin_symbol}
                  />
                  <h6>{coin.coin_symbol}</h6>
                  <div className={styles.right_text}>
                    <p>
                      Bal:{" "}
                      <span>
                        {coin.balance}
                      </span>
                    </p>
                  </div>
                </label>
              );
            })}
        </div>

        <Button
          fluid
          className={styles.buy_button}
          variant="small_size"
          onClick={handlePlaceOrder}
        >
          Buy Now
        </Button>
      </div>
    </Modal>
  );
};

export default EquityPaymentModal;
